import React, { useState } from 'react';
import { CardBody, NavItem, TabContent, TabPane } from 'reactstrap';

import classnames from 'classnames';
import { Link, NavLink } from 'react-router-dom';

const BasicPills = ({ data }: any) => {
  const [activeTab, setactiveTab] = useState(1);

  function toggleTab(tab: any) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 3) {
        setactiveTab(tab);
      }
    }
  }

  const renderSteps = () => {
    return (
      <React.Fragment>
        <ul className="twitter-bs-wizard-nav nav nav-pills nav-justified">
          {data.length
            ? data.map((item: any, key: any) => {
                const { text, value } = item;
                return (
                  <NavItem>
                    <NavLink
                      to="#"
                      className={classnames({ active: activeTab === 3 })}
                      onClick={() => {
                        setactiveTab(3);
                      }}
                    >
                      <div
                        className="step-icon iconStep1"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title={text}
                      >
                        <i className="bx bx-check"></i>
                      </div>
                    </NavLink>
                  </NavItem>
                );
              })
            : null}
        </ul>

        <ul className="twitter-bs-wizard-nav nav nav-pills nav-justified">
          {data.length
            ? data.map((item: any, key: any) => {
                const { text, value } = item;
                return (
                  <NavItem>
                    <label className='isMilestoneText'>{value} </label>
                  </NavItem>
                );
              })
            : null}
        </ul>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <CardBody>
        <div id="basic-pills-wizard" className="twitter-bs-wizard">
          {renderSteps()}

          {/* <ul className="twitter-bs-wizard-nav nav nav-pills nav-justified"> */}
          {/* <NavItem>
              <NavLink
                to="#"
                className={classnames({ active: activeTab === 1 }, "nav-link")}
                onClick={() => {
                  setactiveTab(1);
                }}
              >
                <div
                  className="step-icon iconStep1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Seller Details"
                >
                  <i className="bx bx-plus-medical"></i>
                </div>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="#"
                className={classnames({ active: activeTab === 1 }, "nav-link")}
                onClick={() => {
                  setactiveTab(1);
                }}
              >
                <div
                  className="step-icon iconStep1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Seller Details"
                >
                  <i className="bx bx-plus-medical"></i>
                </div>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="#"
                className={classnames({ active: activeTab === 1 }, "nav-link")}
                onClick={() => {
                  setactiveTab(1);
                }}
              >
                <div
                  className="step-icon iconStep1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Seller Details"
                >
                  <i className="bx bx-plus-medical"></i>
                </div>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                to="#"
                className={classnames({ active: activeTab === 2 }, "nav-link")}
                onClick={() => {
                  setactiveTab(2);
                }}
              >
                <div
                  className="step-icon iconStep2"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Company Document"
                >
                  <i className=" bx bx-first-aid"></i>
                </div>
              </NavLink>
            </NavItem> */}
          {/*           </ul>
           */}

          {/* <ul className="twitter-bs-wizard-nav nav nav-pills nav-justified">
            <NavItem>
              <label> TEXT!!!! </label>
            </NavItem>
            <NavItem>
              <label> TEXT!!!! </label>
            </NavItem>
            <NavItem>
              <label> TEXT!!!! </label>
            </NavItem>
            <NavItem>
              <label> TEXT!!!! </label>
            </NavItem>
            <NavItem>
              <label> TEXT!!!! </label>
            </NavItem>
          </ul> */}
        </div>
      </CardBody>
    </React.Fragment>
  );
};

export default BasicPills;
